import * as React from 'react';
import { useCLEcommContext } from '../../context/CLEcommContext.js';
import { useProductDetailContext } from '../../../../Context/ProductDetailContext.js';
import { PDPPriceSection } from '../../../../Components/PDPPriceSection/PDPPriceSection.js';

const CLPriceSection = ({ className  })=>{
    var ref, ref1;
    const { activeVariant  } = useProductDetailContext();
    const { state  } = useCLEcommContext();
    const { purchaseType  } = state.configurations;
    const price = activeVariant.purchaseTypePrices && activeVariant.purchaseTypePrices[purchaseType];
    if (!price) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(PDPPriceSection, {
        className: className,
        originalPrice: price.originalPrice,
        discountedPrice: price.discountedPrice,
        discountDescription: (ref = price.discountInfo) === null || ref === void 0 ? void 0 : ref.discountDescription,
        discountBadge: (ref1 = price.discountInfo) === null || ref1 === void 0 ? void 0 : ref1.discountBadge,
        bestPrice: activeVariant.bestPrice
    });
};

export { CLPriceSection };
//# sourceMappingURL=CLPriceSection.js.map
